import APPCONFIG from '../../constants/Config';
import {
  GET_ALERTINGS,
  GET_ALERTINGS_SUCCESS,
  GET_ALERTINGS_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/alerting';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.alerting;
const alerting = (state = initialSettings, action) => {
  switch (action.type) {
    // GET ALERTINGS
    case GET_ALERTINGS:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
        },
      };
    case GET_ALERTINGS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_ALERTINGS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default alerting;



// WEBPACK FOOTER //
// ./reducers/user/alerting.js